export class EcardCategorySelection {
    value?: string;
}